import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import DeerImage from '../assets/DeerImage.jpg';
const Deer = () => {
  return (
    <Box
      id="deer-section"
      component="section"
      sx={{
        background:
          'linear-gradient(to Top,rgb(82, 82, 82) 0%,rgb(106, 106, 106) 100%)',
        color: 'white',
        borderRadius: 2,
        p: 4,
        mb: 15, // Added padding
      }}
    >
      <Container>
        <Grid container alignItems="center">
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              pl: { xs: 3 },
              pr: { xs: 3 },
              pt: { xs: 6, md: 1, lg: 4 },
              pb: { xs: 6, md: 1, lg: 4 },
            }}
          >
            <Box
              component="img"
              src={DeerImage}
              alt="Guide with a harvested deer"
              sx={{
                width: { xs: '100%', md: '60%', lg: '50%' },
                height: 'auto',
                borderRadius: '10px',
                display: 'block',
                mx: 'auto',
              }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            lg={6}
            sx={{
              my: 'auto',
              py: 6,
              pr: { xs: 3, lg: 2 },
              pl: { xs: 3, lg: 0 },
            }}
          >
            <Typography
              variant="h4"
              className="myh2"
              id="Licenses"
              color="white"
              mb={3}
            >
              Prime South Georgia Deer Hunting!
            </Typography>
            <Typography
              variant="body2"
              color="white"
              mb={2}
              opacity={0.8}
              textAlign={'left'}
            >
              Hunt on thousands of acres of prime South Western Georgia deer
              hunting land, just 60 miles north of Tallahassee, Florida. These
              rich agricultural properties border a 29,000-acre research
              facility where deer hunting is prohibited, ensuring low hunting
              pressure and excellent opportunities to harvest mature bucks.
            </Typography>
            <Typography
              variant="h4"
              className="myh2"
              id="Licenses"
              color="white"
              mb={3}
            >
              Fair Chase Deer Hunting in Georgia!
            </Typography>
            <Typography
              variant="body2"
              color="white"
              mb={2}
              opacity={0.8}
              textAlign={'left'}
            >
              Experience authentic fair chase deer hunting in Georgia with no
              high fencing, offering a true challenge. Our hunting grounds are
              renowned for consistently producing trophy bucks, providing
              hunters with an unforgettable experience.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Deer;
